import getFirstValue from 'utils/getFirstValue';

export const mapSurveySettingsToApiModel = ({
  reportSettings = {},
  updateFrequency,
  repeatDuration,
  updateEmails,
  repeatMessage,
  blockedMessage,
  accessDefault,
  accessBlockIp,
  accessAllowIp,
  maxResponses,
  maxResponsesPartial,
  reCaptchaEnabled,
  cutOffDate = {},
  sendWithoutUpdates,
  headerEndEnabled,
  headerLandingEnabled,
  headerQuestionsEnabled,
  headerUuid,
  questionNumberingEnabled,
  isBackButtonEnabled,
}) => ({
  re_captcha_enabled: reCaptchaEnabled,
  report_settings: getFirstValue(reportSettings),
  update_frequency: updateFrequency,
  repeat_duration: repeatDuration,
  update_emails: updateEmails,
  repeat_message: repeatMessage,
  blocked_message: blockedMessage,
  access_default: accessDefault,
  access_block_ip: accessBlockIp,
  access_allow_ip: accessAllowIp,
  max_responses: maxResponses,
  max_responses_partial: maxResponsesPartial,
  close_date: cutOffDate.dateTime,
  timezone: cutOffDate.timezone,
  send_without_updates: sendWithoutUpdates,
  header_end_enabled: headerEndEnabled,
  header_landing_enabled: headerLandingEnabled,
  header_questions_enabled: headerQuestionsEnabled,
  header_uuid: headerUuid,
  is_question_numbering_enabled: questionNumberingEnabled,
  is_back_button_enabled: isBackButtonEnabled,
});
